import { CalculatorValues, LegalForm } from "../types";
import { CalculatorInput } from "../types/api";

export const mapCalculatorValuesToApi = (
  values: CalculatorValues
): CalculatorInput => {
  const {
    legal_form,
    taxation_system,
    single_tax_group,
    vat_payer,
    excise_tax_payer,
    hired_workers,
    workers_count,
  } = values;

  // Map entity type
  const entity_type: "individual" | "legal" =
    legal_form === LegalForm.indEnt ? "individual" : "legal";

  // Map tax system
  let tax_system: "simplified" | "general";
  if (taxation_system === "загальна") {
    tax_system = "general";
  } else {
    // "спрощена" or "спрощена-3-група" -> "simplified"
    tax_system = "simplified";
  }

  // Map tax group
  let tax_group: number | null = null;
  if (single_tax_group) {
    if (single_tax_group === "2-група") {
      tax_group = 2;
    } else if (single_tax_group === "3-група") {
      tax_group = 3;
    } else if (single_tax_group === "4-група") {
      tax_group = 4;
    }
  }

  const result: CalculatorInput = {
    entity_type,
    tax_system,
  };

  // For legal entity with general tax system - send only required fields
  if (entity_type === "legal" && tax_system === "general") {
    result.is_vat_payer = true;
    result.is_excise_payer = false;
    return result;
  }

  // Add tax_group if it exists (for simplified system)
  if (tax_group !== null) {
    result.tax_group = tax_group;
  }

  // For legal entity with simplified system
  if (entity_type === "legal" && tax_system === "simplified") {
    result.is_vat_payer = vat_payer ?? false;
    result.is_excise_payer = excise_tax_payer ?? false;
  }

  // For individual entrepreneur — передаємо наявність і кількість працівників
  if (entity_type === "individual") {
    result.has_employees = hired_workers ?? false;
    if (hired_workers === true && workers_count) {
      result.employees_count = Number(workers_count);
    }
  }

  return result;
};
